import { createSlice } from "@reduxjs/toolkit";
import { 
  fetchSubscriptionTableColumnNames,
  fetchSubscription,
  addSubscription,
  updateSubscription,
  deleteSubscription,
  activateDeactivateSubscription,
  fetchSubscriptionTags
} from "./thunk";

const initialState = {
  subscriptions: [],
  tags: [],
  tableColumnNames: [],
  loading: false,
  error: null,
};

const SubscriptionsSlice = createSlice({
  name: "Subscriptions",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder

    .addCase(fetchSubscriptionTableColumnNames.pending, (state) => {
        state.loading = true;
        state.error = null;
    })
    .addCase(fetchSubscriptionTableColumnNames.fulfilled, (state, action) => {
        state.loading = false;
        state.tableColumnNames = action.payload;
    })
    .addCase(fetchSubscriptionTableColumnNames.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
    })

    .addCase(fetchSubscription.pending, (state) => {
        state.loading = true;
        state.error = null;
    })
    .addCase(fetchSubscription.fulfilled, (state, action) => {
        state.loading = false;
        state.subscriptions = action.payload;
    })
    .addCase(fetchSubscription.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
    })

    .addCase(addSubscription.pending, (state) => {
        state.error = null;
    })
    .addCase(addSubscription.fulfilled, (state, action) => {
        state.subscriptions.unshift(action.payload);
    })
    .addCase(addSubscription.rejected, (state, action) => {
        state.error = action.payload;
    })

    .addCase(updateSubscription.pending, (state) => {
        state.error = null;
    })
    .addCase(updateSubscription.fulfilled, (state, action) => {
        const index = state.subscriptions.findIndex(
            (item) => item.ID === action.payload.ID
        );
        if (index !== -1) {
            state.subscriptions[index] = action.payload;
        }
    })
    .addCase(updateSubscription.rejected, (state, action) => {
        state.error = action.payload;
    })

    .addCase(deleteSubscription.pending, (state) => {
        state.error = null;
    })
    .addCase(deleteSubscription.fulfilled, (state, action) => {
        state.subscriptions = state.subscriptions.filter(
            (item) => item.ID !== action.payload[0].ID
        );
    })
    .addCase(deleteSubscription.rejected, (state, action) => {
        state.error = action.payload;
    })

    .addCase(activateDeactivateSubscription.pending, (state) => {
        state.error = null;
    })
    .addCase(activateDeactivateSubscription.fulfilled, (state, action) => {
        const index = state.subscriptions.findIndex(
            (item) => item.ID === action.payload.ID
        );
        if (index !== -1) {
            state.subscriptions[index] = action.payload;
        }
    })
    .addCase(activateDeactivateSubscription.rejected, (state, action) => {
        state.error = action.payload;
    })

    .addCase(fetchSubscriptionTags.pending, (state) => {
        state.error = null;
    })
    .addCase(fetchSubscriptionTags.fulfilled, (state, action) => {
        state.tags = action.payload;
    })
    .addCase(fetchSubscriptionTags.rejected, (state, action) => {
        state.error = action.payload;
    })
  },
});

export default SubscriptionsSlice.reducer;
